export enum Storage {
  ACCESS_TOKEN = 'aktiia_auth_token',
  REFRESH_TOKEN = 'aktiia_auth_refresh_token',
  CLASSIFICATION = 'aktiia_classification',
  USERNAME = 'aktiia_auth_email',
}
